import $ from "jquery";
import {Module} from "../plugins/_application";

/*
 -------------------------------
 Class
 -------------------------------
 */

export default class Navigation extends Module {
	ready(app) {
		/**
		 * Responsive Nav
		 */
		var header = $('#main_header'),
			pullMenu = $('.pull_menu'),
			line1 = $('.line-1'),
			line2 = $('.line-2'),
			line3 = $('.line-3'),
			nav = $('nav#main_nav'),
			canToggle = true,
			body = $('body');

		pullMenu.click(function() {

			var offset = $(window).scrollTop();

			if(canToggle) {
				canToggle = false;
				if(offset < 50){
					header.toggleClass('scrolled')
				}
				nav.css('transition', '300ms all ease');
				nav.toggleClass('pull_menu_in_out');
				line1.toggleClass('line-1-animate');
				line2.toggleClass('line-2-remove');
				line3.toggleClass('line-3-animate');
				body.toggleClass('no-scroll');

				setTimeout(function() {
					canToggle = true;
					nav.css('transition', 'none');
				}, 300);
			}
			// nav.css('transition', 'none');
			// body.toggleClass('no-scroll');
		});

		/**
		 * Add class to the navigation when scrolling down
		 */
		function scrolled() {
			var offset = $(window).scrollTop();
			var header = $('header#main_header')
			var scrolledClass = 'scrolled';

			if(offset > 50) {
				header.addClass(scrolledClass);
			} else {
				header.removeClass(scrolledClass);
			}
		}

		$(window).scroll(scrolled);

		$('li.menu-item-has-children').each(function() {

			var item = $(this);
			var link = item.children('a');
			var subItems = item.children('ul.sub-menu').children('li');
			var toggle = $('<button type="button" class="submenu-toggle" aria-expanded="false"></button>');

			toggle.attr('aria-label', link.text().trim());
			link.after(toggle);

			function toggleSubmenu() {
				var open = !item.hasClass('submenu-open');

				toggle.attr('aria-expanded', open ? 'true' : 'false');

				if (open) {
					item.addClass('submenu-open');

					var time = 100;

					subItems.each(function() {
						var obj = $(this);
						setTimeout(function() {
							obj.addClass('slide-in');
						}, time);
						time += 50;
					});
				} else {
					subItems.removeClass('slide-in');
					item.removeClass('submenu-open');
				}
			}

			toggle.on('click', toggleSubmenu);

			link.on('click', function(e) {
				if (!toggle.is(':visible')) {
					return;
				}

				if (!link.attr('href') || link.attr('href') === '#') {
					toggleSubmenu();
				}
			});

		});

		$('.menu-item-has-children > a[href="#"]').on('click', function(e){
			e.preventDefault();
		});

		$('.cover-link').click(function(e){
			e.preventDefault();
			var div = $(this).attr('href');
			$('html, body').animate({
		        scrollTop: $(div).offset().top - 80
		    }, 500);
		});
	}
}